export const newsItems = [
  {
    img: "https://static.readdy.ai/image/e643b173cc54a8b3f926f18f1e409a57/685d1140d6eba86c24c5cf0d8e85f90e.jpeg",
    category: "お知らせ",
    date: "2026.04.10",
    title: "訪問介護サービスの対応エリアを拡大しました",
    excerpt: "この度、ヘルパーステーションみりんでは刈谷市内の対応エリアをさらに拡大いたしました。詳細はお問い合わせください。",
  },
  {
    img: "https://static.readdy.ai/image/e643b173cc54a8b3f926f18f1e409a57/75200f8f91b4f7ab73d8f9dd2a7c1523.webp",
    category: "採用情報",
    date: "2026.03.28",
    title: "【採用情報】ヘルパースタッフを募集しています",
    excerpt: "ヘルパーステーションみりんでは、一緒に働いてくださるヘルパースタッフを募集しています。未経験の方も歓迎です。",
  },
  {
    img: "https://static.readdy.ai/image/e643b173cc54a8b3f926f18f1e409a57/4c0ed6b873a1656a791ca8faeb51cd01.jpeg",
    category: "お知らせ",
    date: "2026.03.01",
    title: "障害福祉サービスの提供を開始しました",
    excerpt: "この度、ヘルパーステーションみりんでは障害福祉サービス（居宅介護・重度訪問介護）の提供を開始いたしました。",
  },
];

export const categoryColors: Record<string, string> = {
  "お知らせ": "text-[#3ab5c6] border-[#3ab5c6]",
  "採用情報": "text-orange-500 border-orange-400",
};